const CfopParameterization = () => import('./pages/CfopParameterization.vue');
const CfopParameterizationForm = () => import('./pages/CfopParameterizationForm.vue');

export default [
  {
    path: '/fiscal/cfop-parameterization',
    name: 'CfopParameterization',
    component: CfopParameterization,
    meta: {
      title: 'Parametrização de CFOP',
    },
  },
  {
    path: '/fiscal/cfop-parameterization/new',
    name: 'CfopParameterizationRegister',
    component: CfopParameterizationForm,
    meta: {
      title: 'Nova Parametrização',
    },
  },
  {
    path: '/fiscal/cfop-parameterization/edit/:id',
    name: 'CfopParameterizationEdit',
    component: CfopParameterizationForm,
    meta: {
      title: 'Editar Parametrização',
    },
  },
];
